export default __webpack_public_path__ + "media/images/portfolio/gallery-06-370x220-1397663a5b7e15b7e4173bb0fa351476.jpg";